"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSymbol = void 0;
const react_1 = __importStar(require("react"));
const button_1 = __importStar(require("@clayui/button"));
const clsx_1 = __importDefault(require("clsx"));
const global_context_1 = __importDefault(require("@ocp/global-context"));
const icon_1 = __importStar(require("@ocp/icon"));
Object.defineProperty(exports, "IconSymbol", { enumerable: true, get: function () { return icon_1.IconSymbol; } });
const types_1 = require("./types");
const Button = (0, react_1.forwardRef)((_a, ref) => {
    var { displayType, className, children, size, spritemap, symbol, title } = _a, restProps = __rest(_a, ["displayType", "className", "children", "size", "spritemap", "symbol", "title"]);
    const classes = [
        {
            'btn-small': size === types_1.ButtonSize.Small,
        },
        `btn-${displayType}`,
        className,
    ];
    if (symbol) {
        if (children) {
            return (react_1.default.createElement(button_1.default, Object.assign({}, restProps, { displayType: null, ref: ref, className: (0, clsx_1.default)(classes) }),
                react_1.default.createElement("span", { className: "inline-item inline-item-before" },
                    react_1.default.createElement(icon_1.default, { symbol: symbol })),
                children));
        }
        return (react_1.default.createElement(button_1.ClayButtonWithIcon, Object.assign({}, restProps, { "aria-label": title !== null && title !== void 0 ? title : '', "aria-labelledby": undefined, displayType: null, ref: ref, spritemap: spritemap, symbol: symbol, title: title, className: (0, clsx_1.default)('has-only-icon', classes) })));
    }
    return (react_1.default.createElement(button_1.default, Object.assign({}, restProps, { displayType: null, ref: ref, className: (0, clsx_1.default)(classes) }), children));
});
Button.defaultProps = {
    displayType: types_1.ButtonDisplayType.Primary,
    monospaced: false,
    size: types_1.ButtonSize.Large,
    spritemap: global_context_1.default.spriteMapPath,
    symbol: undefined,
    title: undefined,
};
exports.default = Button;
//# sourceMappingURL=Button.js.map